/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleDeviceUpdate
 */
export interface VehicleDeviceUpdate {
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceUpdate
     */
    vehicleId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceUpdate
     */
    serialNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleDeviceUpdate
     */
    firmwareLastUpdatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleDeviceUpdate
     */
    currentVersion?: string | null;
}

/**
 * Check if a given object implements the VehicleDeviceUpdate interface.
 */
export function instanceOfVehicleDeviceUpdate(value: object): value is VehicleDeviceUpdate {
    return true;
}

export function VehicleDeviceUpdateFromJSON(json: any): VehicleDeviceUpdate {
    return VehicleDeviceUpdateFromJSONTyped(json, false);
}

export function VehicleDeviceUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleDeviceUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleId': json['vehicleId'] == null ? undefined : json['vehicleId'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'firmwareLastUpdatedAt': json['firmwareLastUpdatedAt'] == null ? undefined : (new Date(json['firmwareLastUpdatedAt'])),
        'currentVersion': json['currentVersion'] == null ? undefined : json['currentVersion'],
    };
}

export function VehicleDeviceUpdateToJSON(json: any): VehicleDeviceUpdate {
    return VehicleDeviceUpdateToJSONTyped(json, false);
}

export function VehicleDeviceUpdateToJSONTyped(value?: VehicleDeviceUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleId': value['vehicleId'],
        'serialNumber': value['serialNumber'],
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'] == null ? value['firmwareLastUpdatedAt'] : value['firmwareLastUpdatedAt'].toISOString(),
        'currentVersion': value['currentVersion'],
    };
}

